import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ImagePreviewPipe } from '@ux/pipes/image-preview.pipe';

import { SettingInviteComponent } from '../setting-invite/setting-invite.component';
import { SettingTagComponent } from '../setting-tag/setting-tag.component';

type ActiveTabs = 'user' | 'tag';
interface DialogData {
  data: {
    tab: ActiveTabs;
  };
}

@Component({
  selector: 'app-settings-popup',
  templateUrl: './settings-popup.component.html',
  styleUrls: ['./settings-popup.component.less'],
  imports: [CommonModule, NgStyle, SettingTagComponent, SettingInviteComponent],
  providers: [ImagePreviewPipe],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsPopupComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  dialogRef = inject<DialogRef<SettingsPopupComponent>>(DialogRef<SettingsPopupComponent>);
  data = inject(DIALOG_DATA);

  private readonly dataFromDialog = computed(() => this.state().data);

  private readonly state = signal<DialogData>({
    data: null, // {tab: 'user' || 'tags'}
  });

  public readonly activeTab = computed(() => this.state().data.tab);

  headerActiveLineLeft = signal<number>(0);
  headerActiveLineWidth = signal<number>(0);

  constructor() {
    this.state.update(state => ({ ...state, data: this.data }));
    this.updateActiveLinePosition();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onChangeTab(event: MouseEvent, tab: ActiveTabs): void {
    this.state.update(state => ({ ...state, data: { tab: tab } }));
    this.updateActiveLinePosition();
  }

  private updateActiveLinePosition(): void {
    requestAnimationFrame(() => {
      const activeElement = document.querySelector('.settings-popup__tab_active') as HTMLElement;
      if (activeElement) {
        this.headerActiveLineLeft.set(activeElement.offsetLeft);
        this.headerActiveLineWidth.set(activeElement.offsetWidth);
      }
    });
  }
}
